import { render } from "./WallEditPost.vue?vue&type=template&id=168db975&scoped=true"
import script from "./WallEditPost.vue?vue&type=script&lang=js"
export * from "./WallEditPost.vue?vue&type=script&lang=js"

import "./WallEditPost.vue?vue&type=style&index=0&id=168db975&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-168db975"

export default script